import React, { useEffect, useState } from 'react';

import {
  Breadcrumbs,
  CircularProgress,
  FilledInput,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  Link,
  makeStyles,
  Typography,
} from '@material-ui/core';

import lineEndpoint from 'app/api/services/lineEndpoint';
import Search from '@material-ui/icons/Search';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(2),
  },
  breadcrumb: {
    display: 'inline-flex',
    marginLeft: '20px',
  },
  link: {
    cursor: 'pointer',
  },
}));

function ListsFilters(props) {
  const classes = useStyles();
  const { filters, setFilters, cdLinha, type, hasSituation=true } = props;
  const [situations, setSituations] = useState([]);


  const [searchTxt, setSearchTxt] = useState(filters.txtBusca);

  useEffect(() => {
      setSearchTxt(filters.txtBusca || '');
  }, [filters]);


  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (cdLinha) {
        setLoading(true);
        let response = null;
        if (hasSituation) {
          if (!type || type === 'itinerary') {
            response = await lineEndpoint.getItinerarySituations(cdLinha);
          } else {
            response = await lineEndpoint.getScheduleSituations(cdLinha);
          }
          if (response && response.status === 200) {
            setSituations(response.data);
          }
        }
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cdLinha]);

  const handleTextSearch = (onBlur) => {
    if(onBlur){
      if(searchTxt !== '') return;
    }
    handleChangeFilter('txtBusca', searchTxt);
    // setPage(0);
  };

  const handleClickSituations = (situation) => {
    const temp = { ...filters};
    if (situation) {
      temp.cdLinhaSituacao = situation.cdLinhaSituacao;
    } else {
      delete temp.cdLinhaSituacao;
    }
    setFilters(temp);
  };

  const handleChangeFilter = (key, value) => {
    const temp = { ...filters };
    temp[key] = value;
    setFilters(temp);
  };

  const renderSituations = () => {
    return situations.map(situation => {
      return (
        <Link key={`situation${situation.situacao ? situation.situacao.cdLinhaSituacao : 0}`} color='textPrimary'
              onClick={() => handleClickSituations(situation.situacao)} className={classes.link}>
          {situation.situacao ? situation.situacao.deLinhaSituacao : 'Todos'} (
          {situation.nuRegistros})
        </Link>
      );
    });
  };

  return (
    <>
      {loading && (
        <Grid item xs={12} style={{textAlign:'center'}}>
          <CircularProgress size={16} />
        </Grid>
      )}
      {!loading && (
        <>
          <Grid item xs={9}>
            {situations.length > 0 && (
              <div className={classes.container}>
                <Typography component='h3' color='textPrimary' display='inline'>
                  REVISÕES
                </Typography>
                <Breadcrumbs separator='|' className={classes.breadcrumb}>
                  {renderSituations()}
                </Breadcrumbs>
              </div>
            )}
          </Grid>
          <Grid item xs={3}>
            <FormControl size='small' variant='filled' fullWidth>
              <InputLabel>Buscar</InputLabel>
              <FilledInput
                value={searchTxt}
                onChange={(e) => setSearchTxt(e.target.value)}
                endAdornment={
                  <InputAdornment position='end' onClick={() => handleTextSearch()} style={{cursor: 'pointer'}}>
                    <Search />
                  </InputAdornment>
                }
                aria-describedby='outlined-weight-helper-text'
                inputProps={{
                  'aria-label': 'weight',
                }}
                onBlur={() => {
                  handleTextSearch(true);
                }}
                onKeyPress={(ev) => {
                  if (ev.key === 'Enter') {
                    ev.preventDefault();
                    handleTextSearch();
                  }
                }}
              />
            </FormControl>
          </Grid>
        </>
      )}
    </>
  );
}

export default ListsFilters;
